"use strict";exports.UNKNOWN_VERSION="-1";
//# sourceMappingURL=UnknownVersion.cjs.map
